import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-2808">
      <section className="py-16 bg-white" data-id="element-2809">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2810">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-2811">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-2812">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-2813">
            {/* Main Pages */}
            <div data-id="element-2814">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2815">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-2816">
                <li data-id="element-2817">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2818">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-2819">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2820">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-2821">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2822">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-2823">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2824">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-2825">
                <li data-id="element-2826">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2827">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-2828">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2829">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-2830">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2831">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-2832">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2833">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-2834">
                <li data-id="element-2835">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2836">
                    All Services
                  </Link>
                </li>
                <li data-id="element-2837">
                  <Link to={`/${lang}/services/checkup`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2838">
                    Dental Check-ups
                  </Link>
                </li>
                <li data-id="element-2839">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2840">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-2841">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2842">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-2843">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2844">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-2845">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2846">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-2847">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2848">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-2849">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2850">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-2851">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2852">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-2853">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2854">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-2855">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2856">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-2857">
                <li data-id="element-2858">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2859">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-2860">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2861">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-2862">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2863">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-2864">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2865">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-2866">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2867">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-2868">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2869">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-2870">
                <li data-id="element-2871">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2872">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-2873">
                  <Link to={`/${lang}/blog/skilky-koshtuyut-implanty-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2874">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-2875">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2876">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-2877">
                  <Link to={`/${lang}/blog/likuvannya-zubiv-uk-bez-strakhovky`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2878">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-2879">
                  <Link to={`/${lang}/blog/zubnyi-bil-london-shcho-robyty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2880">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-2881">
                  <Link to={`/${lang}/blog/viniry-london-shcho-potribno-znaty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2882">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-2883">
                  <Link to={`/${lang}/blog/yak-obraty-stomatologa-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2884">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-2885">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2886">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-2887">
                <li data-id="element-2888">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2889">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-2890">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2891">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-2892">
                <li data-id="element-2893">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2894">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-2895">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2896">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-2897">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2898">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-2899">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-2900">
              <div className="flex items-center gap-2" data-id="element-2901">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-2902" />
                <span data-id="element-2903">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-2904">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-2905">
                <Button size="sm" className="gap-2" data-id="element-2906">
                  <Calendar className="w-4 h-4" data-id="element-2907" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-2908">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-2909">
                  <MessageCircle className="w-4 h-4 text-green-600" data-id="element-2910" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-2911">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-2912">
                  <Phone className="w-4 h-4" data-id="element-2913" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}